import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomeQrBarcodeGenerator from './Components/QRC/home-qr-barcode-generator';
import QRGenerator from './Components/QRC/qrcode';
import BarcodeGenerator from './Components/QRC/barcode-generator';


function App() {

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeQrBarcodeGenerator />} />
        <Route path="/qrcode" element={<QRGenerator />} />
        <Route path="/barcode-generator" element={<BarcodeGenerator />} />

      </Routes>
    </Router>
  );
}

export default App;

